import React from 'react';
const tomes = [{
  number: '01',
  title: 'Organización de Carrera y Método de Supervivencia',
  desc: 'Sistema para ordenar la cursada, los apuntes, los parciales y la energía. Retro-planning, Cornell adaptado y archivo maestro.'
}, {
  number: '02',
  title: 'El Maestro del PAE',
  desc: 'Proceso de Atención de Enfermería completo: valoración por dominios, 50 diagnósticos NANDA, NIC, NOC y casos clínicos resueltos.'
}, {
  number: '03',
  title: 'Farmacología y Cálculos Críticos',
  desc: 'Los 10 correctos, fórmulas de dosis y goteo, grupos farmacológicos, vías de administración, insulinas y heparinas.'
}, {
  number: '04',
  title: 'Técnicas y Procedimientos en Sala',
  desc: 'Signos vitales, acceso vascular, sondajes, higiene, movilización, curación de heridas y bioseguridad.'
}, {
  number: '05',
  title: 'Resúmenes de Materias Filtro',
  desc: 'Anatomía y fisiología por sistemas, fisiopatología frecuente, microbiología, glosario médico y preguntas de examen.'
}, {
  number: '06',
  title: 'El Manual del Profesional',
  desc: 'Report y SBAR, documentación legal, comunicación con el equipo, introducción al ECG y Ley de Enfermería en Argentina.'
}];
const includes = ['Plantillas de PAE con NANDA, NIC y NOC listas para usar en trabajos y prácticas', 'Casos clínicos resueltos paso a paso con técnicas y procedimientos reales', 'Checklists de procedimientos y bioseguridad para cada instancia práctica', 'Resúmenes, mnemotecnias y autoevaluación por unidad para rendir con más seguridad'];
export function WhatYouGet() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-8 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(219,234,254) 0%, rgb(240,249,255) 50%, rgb(255,255,255) 100%)'
  }} data-id="element-366">
      <div className="mx-auto max-w-4xl" data-id="element-367">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-1" data-id="element-368">
          Lo que <span className="text-blue-700" data-id="element-369">recibís</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-6" data-id="element-370">
          6 tomos · +360 páginas · Toda la carrera organizada
        </p>

        {/* Tomos */}
        <div className="bg-white border border-blue-700/20 rounded-xl overflow-hidden shadow-sm mb-4" data-id="element-371">
          {/* Header */}
          <div className="bg-blue-700 px-5 py-2.5" data-id="element-372">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-373">
              📚 LOS 6 TOMOS — Toda la carrera en un solo lugar
            </h3>
          </div>

          {/* Tomes list */}
          <div className="divide-y divide-gray-100" data-id="element-374">
            {tomes.map(tome => <div key={tome.number} className="flex items-center gap-4 px-5 py-2.5" data-id="element-375">
                <span className="shrink-0 text-lg font-black text-blue-700/30 w-8 text-center" data-id="element-376">
                  {tome.number}
                </span>
                <div className="flex-1 min-w-0" data-id="element-377">
                  <span className="block text-sm font-black text-gray-900" data-id="element-378">
                    {tome.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-379">
                    {tome.desc}
                  </span>
                </div>
                <span className="shrink-0 text-[10px] font-bold text-blue-700 bg-blue-700/5 border border-blue-700/20 rounded-full px-2 py-0.5" data-id="element-380">
                  60 pág.
                </span>
              </div>)}
          </div>
        </div>

        {/* Cada tomo incluye */}
        <div className="grid grid-cols-2 gap-2" data-id="element-381">
          {includes.map(item => <div key={item} className="flex items-start gap-2 bg-white border border-blue-700/20 rounded-lg px-4 py-2.5" data-id="element-382">
              <span className="shrink-0 text-blue-700 font-bold text-sm" data-id="element-383">
                ✅
              </span>
              <span className="text-xs text-gray-700 leading-5" data-id="element-384">{item}</span>
            </div>)}
        </div>
      </div>
    </section>;
}